<section id="content">
    <form id="form">
        <div class="row">
            <div class="col-md-12 col-xs-12 table-cont">
                <div class="form-group">
                    <div class="card">
                        <div class="card-title">
                            <h2>Prospect Management</h2>
                        </div>

                        <div class="cont">
                            <div class="group">
                                <div class="collapse-title">
                                    Prospect Management
                                    <i class="collapse-icon fa"></i>
                                </div>

                                <div class="table-responsive">
                                    <p-table #dt1 class="table" styleClass="ui-table-customers"
                                        tableStyleClass="table" [value]="prospectsData" [rows]="10"
                                        [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true" scrollHeight="500px"
                                        [resizableColumns]="true" [loading]="loading"
                                        [sortMode]="'single'" [customSort]="true" (sortFunction)="sortTable($event)"
                                        [columnResizeMode]="'fit'" [resizableColumns]="true"
                                        [paginator]="true"
                                        [sortField]="'lastModifiedDate'" [sortOrder]="-1"
                                        [globalFilterFields]="['brands', 'sector', 'customer', 'status', 'oddPercent', 'sales', 'title', 'date', 'serviceValue', 'opportunityName', 'lastModifiedDate']">
                                        <ng-template pTemplate="caption">
                                            <div class="flex" style="float: left;">
                                                <p-button
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write"
                                                    label="Add Prospect" [outlined]="true" icon="pi pi-plus-circle"
                                                    (onClick)="navigateToAddProspect()"></p-button>
                                                <!-- <p-button label="Generate Report" [outlined]="true"
                                                    icon="pi pi-file-excel" (onClick)="generateReport()"
                                                    class="ml-2"></p-button> -->
                                            </div>


                                            <!-- <div class="flex justify-content-between align-items-center">
                                                <h5 class="m-0">Manage Prospects</h5>
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"></i>
                                                    <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                                                </span>
                                            </div> -->

                                            <div style="text-align: right">
                                                <p-splitButton *ngIf="exportMenuItems.length > 0" label="Export to Excel" icon="pi pi-file-excel" 
                                                    (onClick)="exportExcel()" [model]="exportMenuItems"
                                                    styleClass="p-button-success mr-2"></p-splitButton>
                                           
                                                <button type="button" pButton icon="pi pi-file-pdf" iconPos="left"
                                                    label="PDF" (click)="exportPdf()" style="margin-right: 0.5em;"
                                                    class="ui-button-warning"></button>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>#</th>
                                                <th pSortableColumn="title" width="15%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Title
                                                        <p-sortIcon field="title"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="customer" width="15%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Customer
                                                        <p-sortIcon field="customer"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="prospectCreator" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Created By
                                                        <p-sortIcon field="prospectCreator"></p-sortIcon>
                                                    </div>
                                                </th>


                                                <th pSortableColumn="creationDate" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Creation Date
                                                        <p-sortIcon field="creationDate"></p-sortIcon>
                                                    </div>
                                                </th>


                                                <th pSortableColumn="sortableBrand" width="15%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Brands
                                                        <p-sortIcon field="sortableBrand"></p-sortIcon>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="sector" width="15%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Sector
                                                        <p-sortIcon field="sector"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="status" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Status
                                                        <p-sortIcon field="status"></p-sortIcon>
                                                    </div>
                                                </th>
                                                <!-- <th pSortableColumn="_oddPercentNumeric" width="10%">
                                                    <div class="flex align-items-center">
                                                        Odd %
                                                        <p-sortIcon field="_oddPercentNumeric"></p-sortIcon>
                                                    </div>
                                                </th> -->


                                                <th pSortableColumn="date" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Date
                                                        <p-sortIcon field="date"></p-sortIcon>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="serviceValue" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Service Value
                                                        <p-sortIcon field="serviceValue"></p-sortIcon>
                                                    </div>
                                                </th>
                                                
                                                <th pSortableColumn="opportunityOrderPrice" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        SSS
                                                        <p-sortIcon field="opportunityOrderPrice"></p-sortIcon>
                                                    </div>
                                                </th>
                                                <!-- <th width="15%">
                                                    <div class="flex align-items-center">
                                                        Remarks
                                                    </div>
                                                </th> -->





                                                <th pSortableColumn="countOfActivities" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Activities Count
                                                        <p-sortIcon field="countOfActivities"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="sales" width="10%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Sales
                                                        <p-sortIcon field="sales"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="opportunityName" width="15%" pResizableColumn>
                                                    <div class="flex align-items-center">
                                                        Opportunity
                                                        <p-sortIcon field="opportunityName"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th width="15%" alignFrozen="right" pFrozenColumn
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                                                    <div class="flex align-items-center">
                                                        Actions
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    <p-columnFilter field="title" type="text" display="menu" placeholder="Title"></p-columnFilter>
                                                </th>

                                                <th>
                                                    <!-- <p-columnFilter field="customer" type="text" display="menu" placeholder="Customer"></p-columnFilter> -->
                                                        <p-columnFilter
                                                        field="customer"
                                                        matchMode="in"
                                                        display="menu"
                                                        [showMatchModes]="false"
                                                        [showOperator]="false"
                                                        [showAddButton]="false"
                                                        [showMenu]="true"
                                                        >
                                                        <ng-template pTemplate="filter" let-filter="filterCallback">
                                                            <p-multiSelect
                                                            [options]="optionsCustomer"
                                                            [(ngModel)]="selectedCustomers"
                                                            placeholder="Select Customer(s)"
                                                            (onChange)="filter($event.value)"
                                                            optionLabel="label"
                                                            optionValue="value"
                                                            display="chip"
                                                            [filter]="true"
                                                            >
                                                            </p-multiSelect>
                                                        </ng-template>
                                                        </p-columnFilter>

                                                </th>

                                                <th>
                                                    <!-- <p-columnFilter field="prospectCreator" type="text" display="menu" placeholder="Creator Name"></p-columnFilter> -->

                                                   <p-columnFilter
                                                    field="prospectCreator"
                                                    matchMode="in"
                                                    display="menu"
                                                    [showOperator]="false"
                                                    [showMatchModes]="false"
                                                    [showAddButton]="false"
                                                    [showMenu]="true"
                                                    >
                                                    <ng-template pTemplate="filter" let-filter="filterCallback">
                                                        <p-multiSelect
                                                        [options]="optionsCreator"
                                                        [(ngModel)]="selectedCreators"
                                                        placeholder="Select Users"
                                                        (onChange)="filter($event.value)"
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        display="chip"
                                                        [filter]="true"
                                                        >
                                                        </p-multiSelect>
                                                    </ng-template>
                                                    </p-columnFilter>




                                                </th>

                                                <th>
                                                    <p-columnFilter field="creationDate" type="date" display="menu" placeholder="Creation Date"></p-columnFilter>
                                                </th>


                                                <th>
                                                <p-columnFilter
                                                    field="brands"
                                                    matchMode="brandsContains"    
                                                    display="menu"
                                                    [showMatchModes]="false"
                                                    [showOperator]="false"
                                                    [showAddButton]="false"
                                                    [showMenu]="true">
                                                    <ng-template pTemplate="filter" let-filter="filterCallback">
                                                    <p-multiSelect
                                                        [options]="optionsBrand"
                                                        [(ngModel)]="selectedBrands"
                                                        (onChange)="filter($event.value)"
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        display="chip"
                                                        [filter]="true">
                                                    </p-multiSelect>
                                                    </ng-template>
                                                </p-columnFilter>
                                                </th>
                                                <th>
                                                    <!-- <p-columnFilter field="sector" type="text" display="menu" placeholder="Sector"></p-columnFilter> -->
                                                     <p-columnFilter
                                                    field="sector"
                                                    matchMode="in"
                                                    display="menu"
                                                    [showOperator]="false"
                                                    [showMatchModes]="false"
                                                    [showAddButton]="false"
                                                    [showMenu]="true">

                                                    <ng-template pTemplate="filter" let-filter="filterCallback">
                                                        <p-multiSelect
                                                        [options]="optionsSector"
                                                        [(ngModel)]="selectedSectors"
                                                        placeholder="Select Sector(s)"
                                                        (onChange)="filter($event.value)"
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        display="chip">
                                                        </p-multiSelect>
                                                    </ng-template>
                                                    </p-columnFilter>



                                                </th>

                                                <th>
                                                    <p-columnFilter field="status" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                            <p-multiSelect
                                                                [ngModel]="value"
                                                                [options]="getStatusOptions()"
                                                                (onChange)="filter($event.value)"
                                                                placeholder="Select Status(es)"
                                                                [showClear]="true"
                                                                styleClass="p-column-filter w-full">
                                                            </p-multiSelect>
                                                        </ng-template>
                                                    </p-columnFilter>
                                                </th>
                                                <!-- <th>
                                                    <p-columnFilter field="_oddPercentNumeric" type="numeric" display="menu" placeholder="Odd %"></p-columnFilter>
                                                </th> -->


                                                <th>
                                                    <p-columnFilter field="date"  type="date" display="menu" placeholder="Date"></p-columnFilter>

                                                </th>
                                                <th>
                                                    <p-columnFilter field="serviceValue" type="numeric" display="menu" placeholder="Service Value"></p-columnFilter>
                                                </th>
                                                
                                                <th>
                                                    <p-columnFilter field="opportunityOrderPrice" type="numeric" display="menu" placeholder="SSS"></p-columnFilter>
                                                </th>
                                                <!-- <th>
                                                    <p-columnFilter field="remarks" type="text" display="menu" placeholder="Remarks"></p-columnFilter>
                                                </th> -->


                                                <th>
                                                    <p-columnFilter field="countOfActivities" type="numeric" display="menu" placeholder="count Of Activities"></p-columnFilter>
                                                </th>                                                <th>
                                                    <!-- <p-columnFilter field="sales" type="text" display="menu" placeholder="Sales"></p-columnFilter> -->
                                                    <p-columnFilter
                                                    field="sales"
                                                    matchMode="in"
                                                    display="menu"
                                                    [showOperator]="false"
                                                    [showMatchModes]="false"
                                                    [showAddButton]="false"
                                                    [showMenu]="true"
                                                    >
                                                    <ng-template pTemplate="filter" let-filter="filterCallback">
                                                        <p-multiSelect
                                                        [options]="optionsSales"
                                                        [(ngModel)]="selectedSales"
                                                        placeholder="Select Sales"
                                                        (onChange)="filter($event.value)"
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        display="chip"
                                                        >
                                                        </p-multiSelect>
                                                    </ng-template>
                                                    </p-columnFilter>
                                                </th>

                                               <th>
                                                    <p-columnFilter
                                                        field="opportunityName"
                                                        matchMode="opportunityFilter"   
                                                        display="menu"
                                                        [showMatchModes]="false"
                                                        [showOperator]="false"
                                                        [showAddButton]="false"
                                                        [showMenu]="true">
                                                        <ng-template pTemplate="filter" let-filter="filterCallback">
                                                        <p-multiSelect
                                                            [options]="optionsOpportunity"
                                                            [(ngModel)]="selectedOpportunities"
                                                            (onChange)="filter($event.value)"
                                                            optionLabel="label"
                                                            optionValue="value"
                                                            display="chip"
                                                            [filter]="true">
                                                        </p-multiSelect>
                                                        </ng-template>
                                                    </p-columnFilter>
                                                </th>

                                                <th alignFrozen="right" pFrozenColumn
                                                    *ngIf="(authenticationService.applanceRole?.accessLevel || 0) >= accessLevelEnum.read_write">
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template    let-rowgroup="rowgroup" let-rowspan="rowspan" pTemplate="body" let-prospect let-i="rowIndex">
                                            <tr class="prospect-row" (click)="onRowClick($event, prospect)" style="cursor: pointer;" [ngClass]="{'draft-prospect-row': prospect.draftProspect}">
                                                <td>
                                                    {{ i + 1 }}
                                                    <i *ngIf="prospect.draftProspect" class="pi pi-file-edit draft-indicator" pTooltip="Draft Prospect"></i>
                                                </td>
                                                <!-- <td>{{ prospect.title }}</td> -->
                                                 <td>
                                                <div class="ellipsis-text" [title]="prospect.title">
                                                        {{ truncateWords(prospect.title, 6) }}
                                                </div>
                                                </td>

                                                <td>
                                                    <!-- {{ prospect.customer }} -->
                                                    <div class="ellipsis-text" [title]=" prospect.customer">
                                                        {{ truncateWords( prospect.customer, 3) }}
                                                </div>

                                                </td>
                                                <td>{{ prospect.prospectCreator }}</td>
                                                <td>{{ prospect.creationDate | date:'dd/MM/yyyy' }}</td>


                                                <td>
                                                    <!-- {{ prospect.brands }} -->
                                                    <button pButton type="button" icon="pi pi-list"
                                                    class="p-ripple p-element p-button p-component p-button-icon-only p-button-rounded p-button-text"
                                                    (click)="showBrandDialog(prospect.id)"></button>
                                                </td>


                                                <td>{{ prospect.sector }}</td>

                                                <td>{{ prospect.status }}</td>
                                                <!-- <td>{{ prospect.oddPercent }}</td> -->

                                                <td>{{ prospect.date | date:'dd/MM/yyyy' }}</td>
                                                <td>{{ prospect.serviceValue | currency : "$" }} </td>
                                                
                                                <td>
                                                    <span *ngIf="prospect.opportunityOrderPrice">{{ prospect.opportunityOrderPrice | currency : "$" }}</span>
                                                    <span *ngIf="!prospect.opportunityOrderPrice">-</span>
                                                </td>

                                                <td>{{ prospect.countOfActivities }}</td>

                                                <td>{{ prospect.sales }}</td>

                                                <td>
                                                    <div class="ellipsis-text" [title]="prospect.opportunityName || 'Not Linked'">
                                                        <a *ngIf="prospect.opportunityId && authenticationService.cadenceRole?.opportunityManagement" 
                                                           href="javascript:void(0)" 
                                                           class="opportunity-link"
                                                           [attr.data-opportunity-id]="prospect.opportunityId"
                                                           [ngClass]="{'clickable': prospect.opportunityId}"
                                                           (click)="navigateToOpportunityDetails(prospect.opportunityId)">
                                                            <i class="pi pi-external-link" style="margin-right: 5px;"></i>
                                                            {{ truncateWords(prospect.opportunityName, 4) }}
                                                        </a>
                                                        <!-- Show non-clickable text if no opportunityId or no permission -->
                                                        <span *ngIf="!prospect.opportunityId || !authenticationService.cadenceRole?.opportunityManagement">
                                                            {{ prospect.opportunityName ? truncateWords(prospect.opportunityName, 4) : 'Not Linked' }}
                                                        </span>
                                                    </div>
                                                </td>
                                                <!-- <td>{{ prospect.remarks }}</td> -->
                                                <td alignFrozen="right" pFrozenColumn>
                                                    <button pButton *ngIf="false" type="button" icon="pi pi-eye"
                                                        class="p-ripple p-element p-button p-component p-button-icon-only p-button-rounded p-button-text"
                                                        (click)="viewProspect(prospect.id)"></button>

                                                    <button pButton  type="button" icon="pi pi-arrow-right"
                                                        class="p-ripple p-element p-button-success p-component p-button-icon-only p-button-rounded p-button-text"
                                                        [disabled]="!workflowStates[prospect.status]?.length  || prospect.status == 'Closed as Lost' && prospect.status == 'De-Qualified'"
                                                        (click)="openNextStateModal(prospect)"></button>

                                                    <button pButton type="button" icon="pi pi-plus-circle"
                                                        class="p-ripple p-element p-button-info p-component p-button-icon-only p-button-rounded p-button-text"
                                                        pTooltip="Add Activity"
                                                        (click)="openAddActivityDialog(prospect)"></button>

                                                    <button pButton type="button" icon="pi pi-pencil"
                                                        class="p-ripple p-element p-button-warning p-component p-button-icon-only p-button-rounded p-button-text"
                                                        (click)="editProspect(prospect.id)"></button>

                                                    <button pButton type="button" icon="pi pi-trash"
                                                        class="p-ripple p-element p-button-danger p-component p-button-icon-only p-button-rounded p-button-text"
                                                        (click)="deleteProspect(prospect.id)"></button>
                                                </td>
                                            </tr>
                                        </ng-template>                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="12">No prospects found.</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!-- Update Status Dialog -->
    <p-dialog [(visible)]="displayUpdateModal" [style]="{width: '450px'}"
        header="Update Prospect Status" [modal]="true" styleClass="p-fluid">
        <div class="p-field mt-2">
            <label for="currentState">Current Status</label>
            <input type="text" pInputText id="currentState" [value]="currentState" readonly />
        </div>
        <div class="p-field mt-3">
            <label for="nextState">Next Status</label>
            <p-dropdown id="nextState" [(ngModel)]="selectedNextState"
                [options]="statusOptions"
                placeholder="Select Next Status"></p-dropdown>
        </div>
        <div class="p-field mt-3">
            <label for="comment">Comment</label>
            <textarea pInputTextarea id="comment" [(ngModel)]="commentText"
                [rows]="5" [cols]="30" required></textarea>
        </div>
        <div class="p-field mt-3">
            <label for="attachment">Attachment</label>
            <input type="file" id="attachment" (change)="onFileSelect($event)" />
        </div>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancel" icon="pi pi-times"
                class="p-button-text" (click)="closeModal()"></button>
            <button pButton pRipple label="Update" icon="pi pi-check"
                class="p-button-primary"
                [disabled]="!commentText || !selectedNextState"
                (click)="updateProspectStatus(selectedNextState)"></button>
        </ng-template>
    </p-dialog>
</section>


<!-- Brand Dialog -->

<p-dialog header="Brands List" [(visible)]="displayBrands" [modal]="true" [style]="{ width: '500px' }">
  <ng-template pTemplate="content">
    <div *ngIf="selectedProspectBrands.length > 0; else noBrands" class="brand-list">
      <ul>
        <li *ngFor="let brand of selectedProspectBrands">{{ brand }}</li>
      </ul>
    </div>
    <ng-template #noBrands>
      <p class="no-brand">No brands found for this Prospect.</p>
    </ng-template>
  </ng-template>
</p-dialog>

<!-- Add Activity Dialog -->
<p-dialog header="Add Activity" [(visible)]="displayAddActivity" [modal]="true" [style]="{ width: '50rem' }" [maximizable]="true">
  <div class="add-activity-dialog p-3">
    <div class="form-group">
      <!-- Attendance selection -->
      <div class="form-group-wrapper mb-4">
        <label class="field-label mb-2">Attendance:</label>
        <p-multiSelect
            #addActivityAttendanceMultiSelect
            [options]="technicalLeadsOptions"
            optionValue="userId"
            optionLabel="fullName"
            variant="filled"
            [(ngModel)]="newActivityAttendance"
            (onChange)="onActivityAttendanceChange($event)"
            placeholder="Select Technical Leads"
            class="full-width custom-multiselect">

            <ng-template let-option pTemplate="selectedItem">
                <div class="item">{{ option.firstName + " " + option.lastName }}</div>
            </ng-template>

            <ng-template let-option pTemplate="item">
                <span>{{ option.firstName + " " + option.lastName }}</span>
            </ng-template>
        </p-multiSelect>
      </div>

      <!-- Activity Date selection -->
      <div class="form-group-wrapper mb-4">
        <label for="dialogActivityDate" class="field-label mb-2">Activity Date (Optional):</label>
        <p-calendar 
            id="dialogActivityDate" 
            [(ngModel)]="newActivityDate" 
            [showIcon]="true" 
            dateFormat="dd/mm/yy"
            placeholder="Select Date (Optional)"
            styleClass="calendar-fix"
            [style]="{'width':'100%', 'height':'38px'}"
            [inputStyle]="{'height':'38px'}"
            [iconButtonStyle]="{'height':'38px', 'width':'38px'}"
            (onSelect)="onActivityDateChange($event)">
        </p-calendar>
      </div>

      <!-- File Upload -->
      <div class="form-group-wrapper mb-4">
        <label for="dialogActivityAttachment" class="field-label mb-2">Attachment:</label>
        <div class="file-input-wrapper d-flex">
          <input
              type="file"
              id="dialogActivityAttachment"
              (change)="onActivityFileSelect($event)"
              accept="*/*"
              class="flex-grow-1 p-2" />
          <button
              type="button"
              pButton
              icon="pi pi-times"
              label="Clear"
              (click)="clearActivityFileInput()"
              [disabled]="!newActivityAttachment"
              class="p-button-secondary ml-2">
          </button>
        </div>
      </div>

      <!-- Activity Title -->
      <div class="form-group-wrapper mb-4">
        <label class="field-label mb-2">Activity Title:</label>
        <input 
            type="text" 
            pInputText 
            placeholder="Enter activity title" 
            [(ngModel)]="newActivityTitle" 
            class="full-width p-2" 
            style="height: 38px;" />
      </div>
      
      <!-- Activity Description -->
      <div class="form-group-wrapper mb-4">
        <label class="field-label mb-2">Activity Details:</label>
        <textarea 
            pInputTextarea 
            rows="5" 
            placeholder="Enter activity details" 
            [(ngModel)]="newActivityDescription" 
            class="full-width p-2"></textarea>
      </div>
    </div>
    
    <!-- Action Buttons -->
    <div class="form-actions mt-4 pt-3 text-right" style="border-top: 1px solid #dee2e6;">
      <button 
          pButton 
          label="Cancel" 
          icon="pi pi-times"
          class="p-button-secondary mr-2" 
          (click)="closeAddActivityDialog()"></button>
      <button 
          pButton 
          label="Post Activity"
          icon="pi pi-check" 
          (click)="addActivityToProspect()" 
          [disabled]="!newActivityTitle?.trim() || !newActivityDescription?.trim() || newActivityAttendance.length === 0">
      </button>
    </div>
  </div>
</p-dialog>



<p-toast></p-toast>
